import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Next to a client selector: create a client from a blank record, or as a
 * copy of the one selected. « Dupliquer » waits for a selected client.
 */
export default function ClientSelectActions({ entity, selected, onNew, onDuplicate }) {
  const { t } = useTranslation();
  const duplicateLabel = selected
    ? t('clients.duplicateLabel', { name: selected.name })
    : t('clients.duplicateNone');
  return (
    <div className="client-select-actions">
      <button type="button" className="btn btn-secondary btn-sm" onClick={onNew}
        aria-label={t('clients.newTitle', { context: entity })}
        title={t('clients.newTitle', { context: entity })}>
        <span aria-hidden="true">+</span> {t('clients.newShort')}
      </button>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => onDuplicate(selected)}
        disabled={!selected} aria-label={duplicateLabel} title={duplicateLabel}>
        <svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16" fill="none"
          stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round">
          <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
          <path d="M10.5 3.5v-.5A1.5 1.5 0 0 0 9 1.5H3A1.5 1.5 0 0 0 1.5 3v6A1.5 1.5 0 0 0 3 10.5h.5" />
        </svg>
        {' '}{t('clients.duplicate')}
      </button>
    </div>
  );
}
